// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'pipeline';

export const Component = () => (
  <path d='M.958 2.005h22.605v3.928H.958V2.005ZM24.52 6.891V1H0v5.89h24.521ZM3.927 10.817h16.667v3.928H3.927v-3.928ZM21.6 15.702V9.86H2.922v5.843H21.6ZM6.848 19.63h10.824v3.927H6.848V19.63Zm11.782 4.933v-5.891H5.891v5.89h12.74Z' />
);

export const viewBox = '0 0 25 25';
